import { colors } from '../constants';
const styleOverrides = {
  tooltip: ({
    theme
  }) => ({
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.text.primary,
    boxShadow: 'none',
    fontSize: theme.typography.body1.fontSize,
    fontWeight: 'normal',
    maxWidth: 300,
    textAlign: 'center',
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius
  }),
  arrow: {
    color: colors.oriGrey[200],
    '&:before': {
      boxShadow: 'none'
    }
  }
};
const defaultProps = {
  arrow: true
};
export default {
  styleOverrides,
  defaultProps
};
//# sourceMappingURL=MuiTooltip.js.map